import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eqt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function imageUrl(u) {
  if (!u) return "";
  if (/^https?:\/\//i.test(u) || u.startsWith("data:")) return u;
  return `${API}/catalog/image/${u}`;
}

export function pdfUrl(name) {
  if (!name) return "";
  if (/^https?:\/\//i.test(name)) return name;
  return `${API}/catalog/pdf/${name}`;
}

export default api;
